import { RadixBaseUiInteropContext } from "@/shared/hooks/use-radix-base-ui-interop.ts";
import { ReactNode, RefObject } from "react";

type Props = {
    radixElement: RefObject<HTMLElement | null>;
    children: ReactNode;
};
/**
 * Use this provider when rendering Base UI components inside a Radix Dialog.
 * It exposes the Radix dialog ref so Base UI popups render in the dialog layer,
 * which helps with positioning, layering, and interaction behavior (like outside clicks).
 *
 * Note: This interop is currently implemented for multi-select only.
 */
export function RadixBaseUiInteropContextProvider({ radixElement, children }: Props) {
    return <RadixBaseUiInteropContext value={{ radixRef: radixElement }}>{children}</RadixBaseUiInteropContext>;
}
